import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-sovos-redirect',
  template: `
    <div style="min-height:70vh;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px">
      <mat-spinner diameter="48"></mat-spinner>
      <p>Taking you to the Sovos sign-in page…</p>
    </div>`,
})
export class SovosRedirectComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    const base = (environment.apiUrl ?? '').trim().replace(/\/$/, '');
    if (!base) {
      this.router.navigateByUrl('/auth/login');
      return;
    }
    window.location.href = `${base}/sovos/auth/login`;
  }
}
